import { clockService } from "../xr/ClockService";
import { animationFrame$ } from "../../messages/xr/AnimationFrame";
const { updateTween } = require("@modules/app/tween");
export function startup() {
    clockService.init();
    animationFrame$.onInputUpdate$.add(() => {
        updateTween();
    });
}
